import {css} from 'styled-components';

import {ms} from '../../../../styles/normalizeSize';

export const container = css<{$variant?: 'notification' | 'promo'}>`
  width: calc(100vw - ${ms(10)} * 2);
  max-width: ${ms(440)};
  max-height: 90vh;

  ${p => {
    if (p.$variant === 'notification')
      return css`
        height: ${ms(272)};
        max-width: ${ms(339)};
      `;
  }};
`;
